var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 0C24.8688 0 18.8753 1.81812 13.7773 5.22444C8.67942 8.63077 4.70606 13.4723 2.35975 19.1368C0.0134318 24.8013 -0.600472 31.0344 0.59567 37.0478C1.79181 43.0612 4.74428 48.5849 9.0797 52.9203C13.4151 57.2557 18.9388 60.2082 24.9522 61.4043C30.9656 62.6005 37.1987 61.9866 42.8632 59.6403C48.5277 57.2939 53.3693 53.3206 56.7756 48.2227C60.1819 43.1248 62 37.1312 62 31C62 22.7783 58.734 14.8933 52.9203 9.07969C47.1067 3.26606 39.2217 0 31 0ZM31 56C26.0555 56 21.222 54.5338 17.1108 51.7867C12.9995 49.0397 9.79522 45.1352 7.90303 40.5671C6.01084 35.9989 5.51575 30.9723 6.48038 26.1227C7.44501 21.2732 9.82603 16.8186 13.3223 13.3223C16.8187 9.82602 21.2732 7.445 26.1228 6.48037C30.9723 5.51574 35.9989 6.01082 40.5671 7.90301C45.1353 9.7952 49.0397 12.9995 51.7868 17.1107C54.5338 21.222 56 26.0555 56 31C56 37.6304 53.3661 43.9893 48.6777 48.6777C43.9893 53.3661 37.6304 56 31 56Z",
    fill: "#30D158"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 34.7599L21.1199 27.8799L16.8799 32.1199L25.8799 41.1199C26.4424 41.6817 27.2049 41.9972 27.9999 41.9972C28.7949 41.9972 29.5574 41.6817 30.1199 41.1199L46.1199 25.1199L41.8799 20.8799L27.9999 34.7599Z",
    fill: "#30D158"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.778a2a84c813effd68dfbf1f96c9b104.svg";
export { ForwardRef as ReactComponent };